import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'sequence'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/sequence`

class SequenceService {
  about () {
    return Api().get(`${root}/about`)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  delete (id) {
    return Api().delete(`${clientRoot()}/${id}`)
  }

  findById (id) {
    return Api().get(`${clientRoot()}/${id}`)
  }
}

export default new SequenceService()
